import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { db } from "../Firebase";

const Amain = () => {
  const [stats, setStats] = useState({ pending: 0, total: 0, thisMonth: 0, rejected: 0, approved: 0, mandirs: 0, members: 0, hold: 0 });
  const [recentActivity, setRecentActivity] = useState([]);
  const [memberCounts, setMemberCounts] = useState([]);
  const [filters, setFilters] = useState({ state: '', city: '', area: '', mandir: '' });

  useEffect(() => {
    // Real-time registrations listener
    const unsubReg = onValue(ref(db, 'registration'), (snap) => {
      const counts = { pending: 0, total: 0, thisMonth: 0, rejected: 0, approved: 0, members: 0, hold: 0 };
      const activities = [];
      const memberAgg = {};

      if (snap.exists()) {
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();

        Object.entries(snap.val()).forEach(([id, r]) => {
          counts.total++;
          if (r.members) counts.members += Object.keys(r.members).length;

          if (r.meta?.createdAt) {
            const regDate = new Date(r.meta.createdAt);
            if (regDate.getMonth() === currentMonth && regDate.getFullYear() === currentYear)
              counts.thisMonth++;
          }

          const status = r.meta?.status || 'pending';
          if (status === 'pending') counts.pending++;
          else if (status === 'rejected') counts.rejected++;
          else if (status === 'approved') counts.approved++;
          else if (status === 'hold') counts.hold++;

          // Collect for recent activity
          activities.push({
            id,
            name: r.basic?.headName || r.basic?.displayName || 'Unknown',
            status,
            city: r.basic?.city || '',
            mandir: r.basic?.Mandirtype || '',
            createdAt: r.meta?.createdAt || 0,
            approvedAt: r.meta?.approvedAt || null,
            holdAt: r.meta?.holdAt || null,
            rejectedAt: r.meta?.rejectedAt || null,
          });

          // Aggregate member counts by state, city, area, mandir
          const state = r.basic?.state || 'Unknown';
          const city = r.basic?.city || 'Unknown';
          const area = r.basic?.areaType || 'Unknown';
          const mandir = r.basic?.Mandirtype || 'Unknown';
          const memberCount = r.members ? Object.keys(r.members).length : 0;

          const key = `${state}|${city}|${area}|${mandir}`;
          if (!memberAgg[key]) {
            memberAgg[key] = { state, city, area, mandir, count: 0 };
          }
          memberAgg[key].count += memberCount;
        });

        // Sort by most recent event timestamp
        activities.sort((a, b) => {
          const aTime = Math.max(a.createdAt, a.approvedAt || 0, a.holdAt || 0, a.rejectedAt || 0);
          const bTime = Math.max(b.createdAt, b.approvedAt || 0, b.holdAt || 0, b.rejectedAt || 0);
          return bTime - aTime;
        });
      }

      setStats(prev => ({ ...prev, ...counts }));
      setRecentActivity(activities.slice(0, 8));
      setMemberCounts(Object.values(memberAgg));
    });

    // Real-time mandir count
    const unsubMandir = onValue(ref(db, 'masters/jainMandir'), (snap) => {
      setStats(prev => ({ ...prev, mandirs: snap.exists() ? Object.keys(snap.val()).length : 0 }));
    });

    return () => { unsubReg(); unsubMandir(); };
  }, []);

  const timeAgo = (ts) => {
    if (!ts) return '';
    const diff = Date.now() - ts;
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'अभी';
    if (mins < 60) return `${mins} मिनट पहले`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs} घंटे पहले`;
    return `${Math.floor(hrs / 24)} दिन पहले`;
  };

  const statusConfig = {
    approved: { color: '#10b981', bg: '#d1fae5', label: 'अनुमोदित', icon: 'fas fa-check-circle' },
    pending:  { color: '#f59e0b', bg: '#fef3c7', label: 'लंबित',    icon: 'fas fa-clock' },
    hold:     { color: '#8b5cf6', bg: '#ede9fe', label: 'होल्ड',    icon: 'fas fa-pause-circle' },
    rejected: { color: '#ef4444', bg: '#fee2e2', label: 'अस्वीकृत', icon: 'fas fa-times-circle' },
    request_changes: { color: '#3b82f6', bg: '#dbeafe', label: 'बदलाव अनुरोध', icon: 'fas fa-edit' },
  };

  const statCards = [
    { label: 'Pending Approvals',    value: stats.pending,   color: '#10b981', icon: 'fas fa-clock',        link: null },
    { label: 'Total Registrations',  value: stats.total,     color: '#3b82f6', icon: 'fas fa-users',        link: null },
    { label: 'This Month',           value: stats.thisMonth, color: '#f59e0b', icon: 'fas fa-calendar',     link: null },
    { label: 'Approved',             value: stats.approved,  color: '#10b981', icon: 'fas fa-check-circle', link: null },
    { label: 'On Hold',              value: stats.hold,      color: '#8b5cf6', icon: 'fas fa-pause-circle', link: null },
    { label: 'Total Members',        value: stats.members,   color: '#06b6d4', icon: 'fas fa-user-friends', link: null },
    { label: 'Registered Mandirs',   value: stats.mandirs,   color: '#f97316', icon: 'fas fa-place-of-worship', link: null },
    { label: 'Request Changes',      value: null,            color: '#8b5cf6', icon: 'fas fa-envelope',     link: '/requests' },
  ];

  return (
    <div className="container-fluid py-4" style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>

      {/* Stats Cards */}
      <div className="row mb-4">
        {statCards.map((card, i) => (
          <div className="col-xl-3 col-md-6 mb-4" key={i}>
            {card.link ? (
              <NavLink to={card.link} style={{ textDecoration: 'none' }}>
                <StatCard {...card} />
              </NavLink>
            ) : (
              <StatCard {...card} />
            )}
          </div>
        ))}
      </div>

      {/* Recent Activity — Real Time */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
              <h5 className="mb-0">📈 Recent Activity</h5>
              <span className="badge bg-success">🔴 Live</span>
            </div>
            <div className="card-body p-0">
              {recentActivity.length === 0 ? (
                <div className="text-center text-muted py-5">कोई गतिविधि नहीं</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead style={{ backgroundColor: '#f8fafc' }}>
                      <tr>
                        <th className="border-0 ps-4">#</th>
                        <th className="border-0">Registration ID</th>
                        <th className="border-0">मुखिया का नाम</th>
                        <th className="border-0">शहर</th>
                        <th className="border-0">मंदिर</th>
                        <th className="border-0">स्टेटस</th>
                        <th className="border-0">समय</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentActivity.map((a, i) => {
                        const cfg = statusConfig[a.status] || statusConfig.pending;
                        const lastTime = Math.max(a.createdAt, a.approvedAt || 0, a.holdAt || 0, a.rejectedAt || 0);
                        return (
                          <tr key={a.id}>
                            <td className="ps-4 text-muted">{i + 1}</td>
                            <td><code style={{ fontSize: '12px' }}>{a.id}</code></td>
                            <td className="fw-semibold">{a.name}</td>
                            <td className="text-muted">{a.city || '—'}</td>
                            <td className="text-muted" style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.mandir || '—'}</td>
                            <td>
                              <span className="badge rounded-pill px-3 py-1" style={{ backgroundColor: cfg.bg, color: cfg.color, fontSize: '12px' }}>
                                <i className={`${cfg.icon} me-1`}></i>{cfg.label}
                              </span>
                            </td>
                            <td className="text-muted small">{timeAgo(lastTime)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Member Counts by Location — Real Time */}
      <div className="row">
        <div className="col-12">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
              <h5 className="mb-0">👥 सदस्य संख्या स्थान अनुसार</h5>
              <span className="badge bg-success">🔴 Live</span>
            </div>
            <div className="card-body">
              {/* Filters */}
              <div className="row mb-3">
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="राज्य फ़िल्टर"
                    value={filters.state}
                    onChange={(e) => setFilters(prev => ({ ...prev, state: e.target.value }))}
                  />
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="शहर फ़िल्टर"
                    value={filters.city}
                    onChange={(e) => setFilters(prev => ({ ...prev, city: e.target.value }))}
                  />
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="क्षेत्र फ़िल्टर"
                    value={filters.area}
                    onChange={(e) => setFilters(prev => ({ ...prev, area: e.target.value }))}
                  />
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="मंदिर फ़िल्टर"
                    value={filters.mandir}
                    onChange={(e) => setFilters(prev => ({ ...prev, mandir: e.target.value }))}
                  />
                </div>
              </div>
              {memberCounts.length === 0 ? (
                <div className="text-center text-muted py-5">कोई डेटा नहीं</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead style={{ backgroundColor: '#f8fafc' }}>
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">राज्य</th>
                        <th className="border-0">शहर</th>
                        <th className="border-0">क्षेत्र</th>
                        <th className="border-0">मंदिर</th>
                        <th className="border-0">सदस्य संख्या</th>
                      </tr>
                    </thead>
                    <tbody>
                      {memberCounts
                        .filter(item =>
                          (filters.state === '' || item.state.toLowerCase().includes(filters.state.toLowerCase())) &&
                          (filters.city === '' || item.city.toLowerCase().includes(filters.city.toLowerCase())) &&
                          (filters.area === '' || item.area.toLowerCase().includes(filters.area.toLowerCase())) &&
                          (filters.mandir === '' || item.mandir.toLowerCase().includes(filters.mandir.toLowerCase()))
                        )
                        .map((item, i) => (
                          <tr key={`${item.state}-${item.city}-${item.area}-${item.mandir}`}>
                            <td className="ps-4 text-muted">{i + 1}</td>
                            <td>{item.state}</td>
                            <td>{item.city}</td>
                            <td>{item.area}</td>
                            <td>{item.mandir}</td>
                            <td className="fw-bold text-primary">{item.count}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ label, value, color, icon }) => (
  <div className="card border-0 shadow-sm h-100" style={{ borderLeft: `4px solid ${color}`, cursor: value === null ? 'pointer' : 'default' }}>
    <div className="card-body">
      <div className="row no-gutters align-items-center">
        <div className="col mr-2">
          <div className="text-xs font-weight-bold text-uppercase mb-1" style={{ color, fontSize: '11px', fontWeight: '700' }}>{label}</div>
          <div className="h5 mb-0 font-weight-bold">{value !== null ? value : 'View All'}</div>
        </div>
        <div className="col-auto"><i className={`${icon} fa-2x`} style={{ color }}></i></div>
      </div>
    </div>
  </div>
);

export default Amain;
